import React, { useRef } from 'react'
import './Join.css'

const Join = () => {
 
  return (
    <div className="join" id="join-us">
        <div className="left-j">
            <hr />
            <div>
                <span className='stroke-text'>READY TO</span>
                <span> LEVEL UP</span>
            </div>
            <div>
                <span> YOUR BODY</span>
                <span className='stroke-text'> WITH US?</span>
            </div>
        </div>
        <div className="right-j">

            <form action="" className="emailcontain">
                <input type="email" name="user-email" id=""  placeholder='Enter your Email'/>
                <button className='btn btn-join'>Join Now</button>
            </form>
        </div>
    </div>
  )
}

export default Join